import DownloadIcon from '@mui/icons-material/Download'
import {Backdrop, Button, Modal} from '@mui/material'
import ExcelFormEditModal from 'pages/common/ExcelFormEditModal'
import {useState} from 'react'
import {useFlaggedReviewListExcel} from 'pages/customer/hooks/useFlaggedReviewExcelMutation'

/*********************************************************************
 ** 확인이 필요한 수용가(flagged-review) 전용 엑셀 다운로드 모달
 ** 공용 ExcelDownloadModal(pathname 분기 switch)에 의존하지 않고
 ** flagged-review 전용 엔드포인트만 사용한다.
 ** - 다운로드: /customer-issues/excel (현재 검색 필터 그대로)
 ** - 양식지정: ExcelFormEditModal(url=/customer-issues)
 **   프런트 경로는 /customer/flagged-review 지만 백엔드 양식 키는 /customer-issues 이므로
 **   url을 명시적으로 넘긴다.
 *********************************************************************/

// 백엔드 엑셀 양식 조회/저장 시 키로 쓰는 url (프런트 pathname과 다름)
const FLAGGED_REVIEW_EXCEL_URL = '/customer-issues'

interface Props {
  open: boolean
  onClose: () => void
  filter: any // 현재 적용된 조회 필터(appliedFilter)
  officeInfo: any
  cooperInfo: any
}

const FlaggedReviewExcelModal = ({open, onClose, filter, officeInfo, cooperInfo}: Props) => {
  const [formEditOpen, setFormEditOpen] = useState(false)
  const {downloadList, isListDownloading} = useFlaggedReviewListExcel(officeInfo, cooperInfo)

  const handleDownload = () => {
    if (isListDownloading) return
    // 다운로드 성공 시 모달 닫기
    downloadList(filter, {onSuccess: onClose})
  }

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        closeAfterTransition
        slots={{backdrop: Backdrop}}
        slotProps={{backdrop: {timeout: 300}}}
      >
        <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-6 w-full max-w-2xl'>
          <div className='modal-content rounded-2'>
            <div className='modal-header'>
              <span className='modal-title text-[1.25rem] font-semibold p-4'>
                확인이 필요한 수용가 다운로드
              </span>
              <button type='button' className='btn-close' aria-label='Close' onClick={onClose} />
            </div>

            <div style={{padding: '24px 32px'}}>
              <span className='text-sm text-red-600 font-bold'>
                확인이 필요한 수용가에서는 검색 필터에 따라 데이터가 다운로드 됩니다.
              </span>

              <div className='flex items-center gap-4 mt-4'>
                <Button
                  variant={'contained'}
                  size={'large'}
                  color={'secondary'}
                  className={'col-4'}
                  onClick={() => setFormEditOpen(true)}
                >
                  엑셀 양식지정
                </Button>

                <Button
                  variant={'contained'}
                  size={'large'}
                  className='col'
                  disabled={isListDownloading}
                  onClick={handleDownload}
                >
                  <DownloadIcon />
                  <span>데이터 다운로드</span>
                </Button>
              </div>
            </div>

            <div className='flex justify-end px-6 py-4 border-t border-gray-200'>
              <Button variant={'contained'} size={'large'} color={'error'} onClick={onClose}>
                나가기
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      <ExcelFormEditModal
        open={formEditOpen}
        onClose={() => setFormEditOpen(false)}
        url={FLAGGED_REVIEW_EXCEL_URL}
      />
    </>
  )
}

export default FlaggedReviewExcelModal
